import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as criteriaBovenLokaalActions from "../../actions/criteriaBovenLokaalActions";
import * as layoutActions from "../../actions/layoutActions";
import * as domainConstants from "../../constants/DomainConstants";
import * as documentActions from "../../actions/documentActions";
import * as types from "../../constants/ComponentConstants";
import { uploadOneFile, deleteOneFile } from "../common/DownloadUploadFilesHelper";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import AutoBindComponent from "../common/AutoBindComponent";
import BeoordelingscriteriaBovenlokaalForm from "./BeoordelingscriteriaBovenlokaalForm";
import BeoordelingscriteriaBovenlokaalPageHelper from "./BeoordelingscriteriaBovenlokaalPageHelper";
import mergeDeep from "../../util/mergeDeep.js";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import showToastr, { showToastrSuccess, showToastrError, showToastrInfo } from "../../util/toastr.js";

import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";

const MAX_CHECKBOXES_CHECKED = 2;


function hasFilesForDossierComponent(documenten, component) {
	if (documenten) {
		const files = documenten.find(x => x.name === component).files;
		if (files) {
			return files.length > 0 ? true : false;
		}
	}
	return false;
}

class BeoordelingscriteriaBovenlokaalPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			titleSet: false,
			fileSessionStarted: false,
			hasUnsavedChanges: false,
			numberOfCheckedCheckBoxes: 0
		};

		this.pageHelper = new BeoordelingscriteriaBovenlokaalPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.CRITERIABOVENLOKAAL);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.receiveProps(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	// ------------------------------------------------------------------------
	handleOnChange(event) {
		this.pageHelper.onChange(event);
	}

	handleOnCheckBoxChange(event) {
		this.pageHelper.onCheckBoxChange(event);
	}

	handleOnDropFiles(component, files) {
		this.pageHelper.onDropFiles(component, files);
	}

	handleOnDeleteFile(component, fileName) {
		this.pageHelper.onDeleteFile(component, fileName);
	}

	handleOnSave(event) {
		this.pageHelper.onSave(event);
	}

	handleOnChangeBereikDoelgroep(event, i, isFuture) {
		this.pageHelper.onChangeBereikDoelgroep(event, i, isFuture);
	}

	handleOnAddBereikDoelgroep(isFuture) {
		this.pageHelper.onAddBereikDoelgroep(isFuture);
	}

	handleOnRemoveBereikDoelgroep(event, i, isFuture) {
		this.pageHelper.onRemoveBereikDoelgroep(event, i, isFuture);
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}
	componentWillUnmount() {
		this.easterEggHandler.unbind();

	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.beoordelingscriteria) {
			return false;
		}

		return true;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		return (
			<BeoordelingscriteriaBovenlokaalForm
				beoordelingscriteria={this.state.beoordelingscriteria}
				documenten={this.state.documenten}
				setPlannenQuestionToJa={this.state.setPlannenQuestionToJa}
				doelgroepen={this.props.doelgroepen}
				disabled={this.props.loading}
				errors={this.props.errors}
				validationMessageType={this.props.validationMessageType}
				onChange={this.handleOnChange}
				onCheckboxChange={this.handleOnCheckBoxChange}
				onChangeBereikDoelgroep={this.handleOnChangeBereikDoelgroep}
				onAddBereikDoelgroep={this.handleOnAddBereikDoelgroep}
				onRemoveBereikDoelgroep={this.handleOnRemoveBereikDoelgroep}
				onSave={this.handleOnSave}
				onDropFiles={this.handleOnDropFiles}
				onDeleteFile={this.handleOnDeleteFile}
				color={types.COLOR_ORANGE}
				fileTypes={this.props.fileTypes}
				fileSessionStarted={this.state.fileSessionStarted}
				voorbeeldInplantingsplanURL={this.props.voorbeeldInplantingsplanURL}
			/>
		);
	}
}

// ----------------------------------------------------------------------------
BeoordelingscriteriaBovenlokaalPage.propTypes = {
	beoordelingscriteria: PropTypes.object,
	doelgroepen: PropTypes.array.isRequired,
	loading: PropTypes.bool,
	fileTypes: PropTypes.object

};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const beoordelingscriteria = state.beoordelingscriteria;
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((beoordelingscriteria.item) && beoordelingscriteria.item.redenVanStatus == 121450000);
	const infrastructuurId = state.infrastructuren[0] !== undefined ? state.infrastructuren[0].id : null;
	const voorbeeldInplantingsplanURL = state.settings.voorbeeldInplantingsplanURL;

	return {
		loading: disabled,
		beoordelingscriteria: beoordelingscriteria.item,
		doelgroepen: convertToLabelValuePair(state.referentie.doelgroepen),
		errors: beoordelingscriteria.errors,
		validationMessageType: beoordelingscriteria.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		dossierId: dossierId,
		fileTypes: state.settings.fileTypes,
		infrastructuurId: infrastructuurId,
		voorbeeldInplantingsplanURL
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		saveCriteria: bindActionCreators(criteriaBovenLokaalActions.saveCriteriaBovenLokaal, dispatch),
		loadCriteria: bindActionCreators(criteriaBovenLokaalActions.loadCriteriaBovenLokaal, dispatch),
		getEmptyBereikDoelgroep: bindActionCreators(criteriaBovenLokaalActions.getEmptyBereikDoelgroep, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadBeoordelingscriteriaPageLayout, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getContent, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(BeoordelingscriteriaBovenlokaalPage));
